module.exports = __webpack_public_path__ + "static/media/kaoShkolnik2020_manuscript.1c6f877b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/papers/kaoShkolnik2020_manuscript.pdf
// module id = 142
// module chunks = 0